import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { FeedbackContact } from '../_models/feedback-contact';
import { Router, ActivatedRoute } from '@angular/router';
import { FeedBackContactService } from '../_services/feedback.service';
import swal from 'sweetalert2';
import { FormsModule } from '@angular/forms';
import { WhiteSpaceValidators } from '../shared/white-space-validator';
import { ValidationErrorMessage } from '../constants/validation';
import { LookupService } from '../_services/lookup.service';
import { LookUpDataForm } from '../_models/lookup';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { Routes, RouterModule } from '@angular/router';
import { __param } from '../../../node_modules/tslib';
import { HomeComponent } from '../home/home.component';
import { SiteHeaderComponent } from '../layout/site-header/site-header.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  feedBackFormGroup: FormGroup;
  feedBackContactDataForm: FeedbackContact = new FeedbackContact();
  //lookUpFeedbackDataFormList: LookUpDataForm[] = [];
  //lookUpNameFeedbackType: String = "feedbackType";
  filteredResults: any;
  feedbackType: Promise<boolean>;
  FeedbackType: string;
  fileToUpload = [];
  fileNames: any[] = [];
  imageSizeError: boolean = false;
  imageTypeError: boolean = false;
  imageCountError: boolean = false;
  imageCount = 0
  imageSizeErrorMessage = ValidationErrorMessage.IMAGE_SIZE;
  imageTypeErrorMessage = ValidationErrorMessage.IMAGE_Type;
  imageCountErrorMessage = ValidationErrorMessage.IMAGE_Count;
  showFileName: boolean = false;
  images = [];
  imagesName = [];
  deletedImage: boolean = true;
 
  constructor(
    private formbuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private lookUpService: LookupService,
    private feedBackContactService: FeedBackContactService,
    private snotifyService: SnotifyService,
  ) { this.router.routeReuseStrategy.shouldReuseRoute = () => false; }

  @ViewChild('attachment',{ static: false })
  attachmentVariable: ElementRef;
  ngOnInit() {
    this.feedBackFormValidate();
    //this.feedbackType=this.feedbackDetailsUrl(feedbackType)
    //this.getFeedbackTypeLookUpValue(this.lookUpNameFeedbackType);
    this.activatedRoute.paramMap.subscribe(params => {
      let stringToSubmit = params.get('feedbackType')
      this.FeedbackType = stringToSubmit
      console.log(stringToSubmit);
    });
  }





  /*--- Form Validation---*/
  /*-----Form validations-----*/
  feedBackFormValidate() {
    const mobnumPattern = "^[0-9+]*$";
    const namePattern = "^[A-Za-z\\s-]+$";
    const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

    this.feedBackFormGroup = this.formbuilder.group({

      eMail: ['', [Validators.required, Validators.pattern(emailPattern), WhiteSpaceValidators.emptySpace()]],
      name: ['', [Validators.required, Validators.pattern(namePattern), WhiteSpaceValidators.emptySpace()]],
      message: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      address1: ['',],
      address2: ['',],

      contactFeedBackType: ['',],
      subject: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      url: ['',],
      fax: ['', [Validators.pattern(mobnumPattern)]],
      mobileNo: ['', [Validators.required, Validators.pattern(mobnumPattern), WhiteSpaceValidators.emptySpace()]],
      images: [[]],


    });

  }
  reset() {
    this.feedBackFormGroup.reset();
    this.feedBackFormGroup.controls['eMail'].clearValidators()
    this.feedBackFormGroup.controls['name'].clearValidators()
    this.feedBackFormGroup.controls['message'].clearValidators()
    this.feedBackFormGroup.controls['subject'].clearValidators()
    this.feedBackFormGroup.controls['fax'].clearValidators()
    this.feedBackFormGroup.controls['mobileNo'].clearValidators()
    this.feedBackFormGroup.controls['eMail'].updateValueAndValidity()
    this.feedBackFormGroup.controls['name'].updateValueAndValidity()
    this.feedBackFormGroup.controls['message'].updateValueAndValidity()
    this.feedBackFormGroup.controls['subject'].updateValueAndValidity()
    this.feedBackFormGroup.controls['fax'].updateValueAndValidity()
    this.feedBackFormGroup.controls['mobileNo'].updateValueAndValidity()
  }


  /*---Error Message for name---*/
  getErrorMsgForAddFeedbackFormName() {
    return this.feedBackFormGroup.controls.name.errors.required ? ValidationErrorMessage.REQUIRED :
      this.feedBackFormGroup.controls.name.errors.minlength ? ValidationErrorMessage.MIN_LENGTH_THREE :
        this.feedBackFormGroup.controls.name.errors.pattern ? ValidationErrorMessage.ALPHABET :
          this.feedBackFormGroup.controls.name.errors.whitespace ? ValidationErrorMessage.REQUIRED :
            '';
  }
  /*---Error Message for eMail---*/
  getErrorMsgForAddFeedbackFormEmail() {
    return this.feedBackFormGroup.controls.eMail.errors.required ? ValidationErrorMessage.REQUIRED :
      this.feedBackFormGroup.controls.eMail.errors.pattern ? ValidationErrorMessage.VALID_EMAIL :
        this.feedBackFormGroup.controls.eMail.errors.whitespace ? ValidationErrorMessage.REQUIRED :
          '';
  }
  /*---Error Message for mobileNo---*/
  getErrorMsgForAddFeedbackMobileNumber() {
    return this.feedBackFormGroup.controls.mobileNo.errors.required ? ValidationErrorMessage.REQUIRED :
      this.feedBackFormGroup.controls.mobileNo.errors.pattern ? ValidationErrorMessage.VALID_MOBILE :
        this.feedBackFormGroup.controls.mobileNo.errors.whitespace ? ValidationErrorMessage.REQUIRED :
          this.feedBackFormGroup.controls.mobileNo.errors.minlength ? ValidationErrorMessage.VALID_MOBILE :
            this.feedBackFormGroup.controls.mobileNo.errors.maxlength ? ValidationErrorMessage.VALID_MOBILE :



              '';

  }
  /*---Error Message for subject---*/
  getErrorMsgForAddFeedbackSubject() {
    return this.feedBackFormGroup.controls.subject.errors.required ? ValidationErrorMessage.REQUIRED :
      this.feedBackFormGroup.controls.subject.errors.whitespace ? ValidationErrorMessage.REQUIRED :
        '';
  }
  /*---Error Message for message---*/
  getErrorMsgForAddFeedbackMessage() {
    return this.feedBackFormGroup.controls.message.errors.required ? ValidationErrorMessage.REQUIRED :
      this.feedBackFormGroup.controls.message.errors.whitespace ? ValidationErrorMessage.REQUIRED :
        '';
  }
  /*---Error Message for fax---*/
  getErrorMsgForAddFeedbackFaxNumber() {
    return this.feedBackFormGroup.controls.fax.errors.pattern ? ValidationErrorMessage.VALID_FAX :

      this.feedBackFormGroup.controls.fax.errors.maxlength ? ValidationErrorMessage.VALID_FAX :


        '';
  }

  /* Selected Image is Handled using events */
  onFileChanged(event) {

    this.showFileName = true;
    for (let i = 0; i < event.target.files.length; i++) {
      let file = event.target.files[i];
      let fileName = event.target.files[i].name
      let imageSize = event.target.files[i].size;
      let imagetype = event.target.files[i].type;
      console.log(fileName, imageSize, imagetype)
      this.imagesName.push(fileName);


      this.imageSizeError = false;
      if (imagetype == 'image/jpeg' || imagetype == 'image/png' ||
        imagetype == 'image/tif' || imagetype == 'image/jpg' || imagetype == 'application/pdf') {
        this.imageTypeError = false;
        if (this.imageCount < 5) {
          this.showFileName = true;
          this.fileNames.push(fileName);
          this.fileToUpload.push(file)
          this.imageCount++;
          this.imageCountError = false
          console.log(this.imageCount)
        }

        else {
          this.imageCountError = true
          this.onCancelAttachment(this.imagesName)
          console.log(this.imagesName)
          let msg = "Maximum 5 attachment allowed";
          let action = ''
          this.snotifyService.error(msg, action, {
            timeout: 3000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            position: SnotifyPosition.rightBottom
          })

        }
      }


      else {
        this.imageTypeError = true;
        this.onCancelAttachment(this.imagesName)
        console.log(this.imagesName)
        let msg = "Image extension should be (.jpeg/.jpg/.png/.tif/.gif/.pdf)";
        let action = ''
        this.snotifyService.error(msg, action, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.rightBottom
        })


      }



    }
  }

  /* cancel Attachment File*/
  onCancelAttachment(imagesName) {
    this.attachmentVariable.nativeElement.value = "";
    var index = this.imagesName.indexOf(imagesName)
    imagesName.splice(index, 1)
    this.fileToUpload.splice(index, 1)
  }


  /*-----Method for submitting contact us form-----*/
  submitContactUsForm() {
    if (this.feedBackFormGroup.valid) {
      this.feedBackContactDataForm.address1 = this.feedBackFormGroup.get('address1').value;
      this.feedBackContactDataForm.address2 = this.feedBackFormGroup.get('address2').value;
      this.feedBackContactDataForm.eMail = this.feedBackFormGroup.get('eMail').value;
      this.feedBackContactDataForm.fax = this.feedBackFormGroup.get('fax').value;
      this.feedBackContactDataForm.contactFeedBackType = this.FeedbackType;
      this.feedBackContactDataForm.message = this.feedBackFormGroup.get('message').value;
      this.feedBackContactDataForm.mobileNo = this.feedBackFormGroup.get('mobileNo').value;
      this.feedBackContactDataForm.name = this.feedBackFormGroup.get('name').value;
      this.feedBackContactDataForm.subject = this.feedBackFormGroup.get('subject').value;
      this.feedBackContactDataForm.url = this.feedBackFormGroup.get('url').value;
      // this.feedBackContactDataForm.attachment=this.feedBackFormGroup.get('attachment').value;
      //this.feedBackContactDataForm.images=this.images;
      console.log(this.feedBackContactDataForm)
      this.feedBackContactService.saveFeedBackAndContact(this.feedBackContactDataForm, this.fileToUpload).subscribe(
        resp => {
          // console.log(resp)
          if (resp != null) {
            let msg = "Data saved successfully";
            let action = ''
            this.snotifyService.success(msg, action, {
              timeout: 3000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              position: SnotifyPosition.rightBottom
            })
             // this.feedBackFormGroup.reset();
             this.reset();

            
          } else{
            let msg = "Something went wrong";
            let action = ''
            this.snotifyService.error(msg, action, {
              timeout: 3000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              position: SnotifyPosition.rightBottom
            })

          }
        })
    }
  }
}






